import find from "lodash/find";

import * as types from "./actionTypes";
import { showModalSuccess } from "./modalActions";
import { showAlertSuccess } from "./alertActions";
import callService from "../services/callService";
import { toggleLoader } from "./loaderActions";

export function loadCallSuccess(calls) {
  return {
    type: types.LOAD_CALL_SUCCESS,
    calls,
    meta: {
      throttle: true
    }
  };
}

export function getCallSuccess(call) {
  return {
    type: types.GET_CALL_SUCCESS,
    call
  };
}

export function bulkApproveSuccess() {
  return {
    type: types.BULK_APPROVE_SUCCESS
  };
}

export function savingCall(status = true) {
  return {
    type: types.SAVING_CALL,
    savingCall: status
  };
}

export function createCallSuccess(call) {
  return {
    type: types.CREATE_CALL_SUCCESS,
    call
  };
}

export function getRecurrenceSuccess(recurrence) {
  return {
    type: types.GET_RECURRENCE_SUCCESS,
    recurrence
  };
}

export function getRecurringCallsSuccess(calls) {
  return {
    type: types.GET_RECURRING_CALLS_SUCCESS,
    calls
  };
}

export function updateCallSuccess(call) {
  return {
    type: types.UPDATE_CALL_SUCCESS,
    call
  };
}

export function clearCallSuccess() {
  return { type: types.RESET_CALL_SUCCESS, call: {} };
}

export function clearApprovedCalls() {
  return {
    type: types.DESELECT_ALL_CALLS
  };
}

export function toggleCall(id) {
  return {
    type: types.TOGGLE_CALL,
    id
  };
}

export function toggleRecurringCall(id) {
  return {
    type: types.TOGGLE_RECURRING_CALL,
    id
  };
}

export function updateCallApprovalToNotify(callApprovalToNotify) {
  return {
    type: types.GET_CALL_APPROVAL_TO_NOTIFY,
    callApprovalToNotify
  };
}

export function requestCallId(call, SAVING = false) {
  return (dispatch) => {
    if (SAVING) {
      dispatch({
        type: types.REQUEST_CALL_SAVE,
        callToSave: call
      });
      dispatch(showModalSuccess("callSaveModal"));
    } else {
      dispatch({
        type: types.REQUEST_CALL_DELETE,
        callToDelete: call
      });
      dispatch(showModalSuccess("callConfirmModal"));
    }
  };
}

export function requestPartId(partId) {
  // console.log("partId", partId);
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_PART_ID,
      partToDelete: partId
    });
    dispatch(showModalSuccess("partDeleteModal"));
  };
}

export function deleteCallSuccess(callId) {
  return {
    type: types.DELETE_CALL_SUCCESS,
    callId
  };
}

export function getDateRangeSuccess(range) {
  return {
    type: types.GET_DATE_RANGE_SUCCESS,
    range
  };
}

export function loadCalls(body) {
  return (dispatch) => {
    dispatch(toggleLoader(true));
    return callService
      .loadCalls(body)
      .then((data) => {
        dispatch(toggleLoader(false));
        dispatch(loadCallSuccess(data));
        return data;
      })
      .catch((error) =>
        dispatch(showAlertSuccess("Unable to load calls.", "error"))
      );
  };
}

export function loadCallsByProjectId(id) {
  return (dispatch) => {
    dispatch(toggleLoader(true));
    return callService
      .loadCallsByProjectId(id)
      .then((data) => {
        dispatch(toggleLoader(false));
        dispatch(loadCallSuccess(data));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}

export function loadCallsByUserId(id) {
  return (dispatch) =>
    callService
      .loadCallsByUserId(id)
      .then((data) => dispatch(loadCallSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function loadCallsByStageId(id) {
  return (dispatch) =>
    callService
      .loadCallsByStageId(id)
      .then((data) => dispatch(loadCallSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function getCall(id, showCALLDetails = false) {
  return (dispatch) =>
    callService
      .getCall(id)
      .then((call) => {
        dispatch(getCallSuccess(call));
        if (showCALLDetails) {
          dispatch(showModalSuccess("callDetailsModal"));
        }
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function createCall(call, action, shouldAlert = true) {
  return (dispatch) => {
    dispatch(savingCall());
    return callService
      .createCall(call)
      .then((createdCall) => {
        dispatch(createCallSuccess(createdCall));
        dispatch(savingCall(false));

        let alert = "";
        switch (action) {
          case "TIMESHEET":
            alert = "Timesheet updated successfully";
            break;
          default:
            alert = "Call created successfully";
            break;
        }
        if (shouldAlert) {
          dispatch(showAlertSuccess(alert, "success"));
        }
        return createdCall;
      })
      .catch((error) => {
        dispatch(savingCall(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updateCall(call, action) {
  return (dispatch) => {
    dispatch(savingCall());
    return callService
      .updateCall(call)
      .then((updatedCall) => {
        dispatch(updateCallSuccess(updatedCall));
        dispatch(savingCall(false));
        let alert = "";
        switch (action) {
          case "BULK":
            alert = "Calls updated successfully";
            break;
          case "TIMESHEET":
            alert = "Timesheet updated successfully";
            break;
          default:
            alert = "Call updated successfully";
            break;
        }

        dispatch(showAlertSuccess(alert, "success"));
      })
      .catch((error) => {
        dispatch(savingCall(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function deleteCall(id, action) {
  return (dispatch) =>
    callService
      .deleteCall(id)
      .then(() => {
        dispatch(deleteCallSuccess(id));

        let alert = "";
        switch (action) {
          case "TIMESHEET":
            alert = "Timesheet updated successfully";
            break;
          default:
            alert = "Call deleted successfully";
            break;
        }
        dispatch(showAlertSuccess(alert, "success"));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function getRecurringCalls(id) {
  return (dispatch) =>
    callService
      .getRecurringCalls(id)
      .then((calls) => {
        dispatch(getRecurringCallsSuccess(calls));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function createRecurringCalls(calls, recurrence) {
  return (dispatch) => {
    dispatch(savingCall());
    return callService
      .createRecurringCalls(calls, recurrence)
      .then((createdCalls) => {
        dispatch(createCallSuccess(createdCalls));
        dispatch(savingCall(false));
        dispatch(showAlertSuccess("Calls created successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingCall(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updateRecurringCalls(recurringId, data) {
  return (dispatch) => {
    dispatch(savingCall());
    return callService
      .updateRecurringCalls(recurringId, data)
      .then((updatedCalls) => {
        const updatedCall = find(updatedCalls, { _id: data._id });
        dispatch(updateCallSuccess(updatedCall));
        dispatch(savingCall(false));
        dispatch(showAlertSuccess("Calls updated successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingCall(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function deleteRecurringCalls(id) {
  return (dispatch) => {
    dispatch(savingCall());
    return callService
      .deleteRecurringCalls(id)
      .then(() => {
        dispatch(deleteCallSuccess(id));
        dispatch(savingCall(false));
        dispatch(showAlertSuccess("Calls deleted successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingCall(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function getRecurrence(id, showCALLDetails = false) {
  return (dispatch) => {
    if (id) {
      return callService
        .getRecurrence(id)
        .then((recurrence) => {
          dispatch(getRecurrenceSuccess(recurrence));
          if (showCALLDetails) {
            dispatch(showModalSuccess("recurringCallsModal"));
          }
        })
        .catch((error) =>
          dispatch(showAlertSuccess(error.description, "error"))
        );
    }
    if (showCALLDetails) {
      dispatch(showModalSuccess("recurringCallsModal"));
    }
  };
}

export function clearCall() {
  return (dispatch) => {
    dispatch(clearCallSuccess());
  };
}

export function clearRecurrence() {
  return (dispatch) => {
    dispatch(getRecurrenceSuccess({}));
  };
}

export function bulkApprove(idArray, user, stage) {
  return (dispatch) =>
    callService
      .bulkApprove(idArray, user, stage._id)
      .then((responseArray) => {
        const numModified = Array.isArray(responseArray)
          ? responseArray.length
          : 0;
        dispatch(
          showAlertSuccess(
            `${numModified} ${numModified === 1 ? "call" : "calls"} ${
              stage.label
            }`,
            "success"
          )
        );
      })
      .catch((error) => {
        dispatch(showAlertSuccess(error.description, "error"));
      });
}

export function getDateRange(period) {
  return (dispatch) => {
    dispatch(getDateRangeSuccess(period));
  };
}

export function createPart(call, part) {
  return (dispatch) => {
    dispatch(savingCall());
    return callService
      .createPart(call, part)
      .then((updatedCall) => {
        dispatch(updateCallSuccess(updatedCall));
        dispatch(savingCall(false));
        dispatch(showAlertSuccess("Part created successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingCall(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updatePart(call, part) {
  return (dispatch) => {
    dispatch(savingCall());
    return callService
      .updatePart(call, part)
      .then((updatedCall) => {
        dispatch(updateCallSuccess(updatedCall));
        dispatch(savingCall(false));
        dispatch(showAlertSuccess("Part updated successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingCall(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function deletePart(call, part) {
  return (dispatch) =>
    callService
      .deletePart(call, part)
      .then((updatedCall) => {
        dispatch(updateCallSuccess(updatedCall));
        dispatch(showAlertSuccess("Part deleted successfully", "success"));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function createHoliday(call, shouldAlert = true) {
  return (dispatch) => {
    dispatch(savingCall());
    return callService
      .createHoliday(call)
      .then((createdCall) => {
        dispatch(createCallSuccess(createdCall));
        dispatch(savingCall(false));

        const alert = "Holiday created successfully";
        if (shouldAlert) {
          dispatch(showAlertSuccess(alert, "success"));
        }
        return createdCall;
      })
      .catch((error) => {
        dispatch(savingCall(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}
export function createIndividualHoliday(call, users, shouldAlert = true) {
  return (dispatch) => {
    dispatch(savingCall());
    return callService
      .createIndividualHoliday(call, users)
      .then((createdCall) => {
        dispatch(createCallSuccess(createdCall));
        dispatch(savingCall(false));

        const alert = "Holiday created successfully";
        if (shouldAlert) {
          dispatch(showAlertSuccess(alert, "success"));
        }
        return createdCall;
      })
      .catch((error) => {
        dispatch(savingCall(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}
export function notifyCallApproval(id, message) {
  return (dispatch) =>
    callService
      .notifyCallApproval(id, message)
      .then((result) => {
        dispatch(updateCallApprovalToNotify({}));
        dispatch(showAlertSuccess("Email sent successfully!", "success"));
        return result;
      })
      .catch((error) => {
        dispatch(showAlertSuccess(error.description, "error"));
      });
}
export function setCallApprovalToNotify(call) {
  return (dispatch) => dispatch(updateCallApprovalToNotify(call));
}
export function migrateMultipleCalls(calls, user, filters) {
  return (dispatch) =>
    callService
      .migrateMultipleCalls(calls, user, filters)
      .then((result) => {
        if (result?.data?.updated) {
          dispatch(
            showAlertSuccess("Call migration finished successfully!", "success")
          );
          return true;
        }
        dispatch(
          showAlertSuccess("Call migration failed. Please, try again", "error")
        );
        return false;
      })
      .catch((error) => {
        dispatch(showAlertSuccess(error.description, "error"));
        return false;
      });
}
